import React from 'react';
import {
  CultivationsForCrop_cultivations,
  CultivationsForDate_cultivations,
  CultivationsForPlot_cultivations,
  UpdateCultivationDenseVariables
} from "../../../../../__generated__/types";
import {Button} from "primereact/button";
import useUpdateCultivationMutation from "../../../../../hooks/useUpateCultivationMutation";
import {createCultivationEvents} from 'shared/utils/domain/cultivation.utils';

interface EventsColumnProps {
  cultivation: CultivationsForCrop_cultivations | CultivationsForDate_cultivations | CultivationsForPlot_cultivations;
}


const EventsColumn = (props: EventsColumnProps) => {
  const {cultivation} = props;
  const [updateCultivationMutation] = useUpdateCultivationMutation();

  const onCreateCultivationEvents = () => {
    let events = createCultivationEvents(cultivation);

    const variables: UpdateCultivationDenseVariables = {
      cultivationId: props.cultivation.id,
      data: {
        events: {
          delete: cultivation.events?.map(({id}) => ({id})),
          create: events
        }
      },
    };


    updateCultivationMutation({
      variables,
      refetchQueries: "active",
    }).then(() => {
    });
  };

  return (
    <div>

      <Button className='w-fit p-0 m-0' text icon={'pi pi-refresh'} onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        onCreateCultivationEvents();
      }}/>

      {props.cultivation.events?.length}
    </div>
  );
};

export default EventsColumn;
